import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const StakingPage: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="h6" align="center">
          Чтобы начать, отправьте Telegram Gift себе на Fragment.
        </Typography>
      </Box>
    </Container>
  );
};

export default StakingPage; 